module.exports = __webpack_public_path__ + "r-v3/img/quiz.485989c2.svg";